<template>
    <div class="bank-details">
        <CaseDocuments :show_documents.sync="modals.show_documents" ref="bankDocuments" :bank="document_bank" :customer_id="product.prod_customer_id"/>
        <PersonalCaseEditBankModal 
            :show_edit_bank.sync="modals.show_edit_bank" 
            :bank="edit_bank" 
            :status="list_sub_personal_loan_status"
            :product="product" 
            v-if="product.product_banks.length > 0"
        />
        <PersonalCaseAddBankModal :show_add_bank.sync="modals.show_add_bank" :product="product" :status="list_sub_personal_loan_status"/>
        <div class="card-table rounded-bottom">
            <el-button @click="showAddBankModal" class="float-right py-0 pr-3 text-primary mb-3" type="text">+ Add Bank</el-button>
            <el-table
            :data="tableData"
            style="width: 100%">
                <el-table-column
                    label="PIC/Bank"
                    min-width="100"
                    >
                    <template slot="header">
                        <div class="d-block">
                            <span class="main-column-label">Bank</span><br>
                            <span class="sub-column-label">/Banker</span>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-image
                            class="rounded mr-2"
                            :src="scope.row.prod_bnk_logo_url"
                            fit="cover"
                            style="height: 15px;"
                        ></el-image>
                        <p class="bottom-line" v-if="scope.row.prod_bnk_banker_detail">{{ scope.row.prod_bnk_banker_detail.name }}</p>
                        <p class="bottom-line" v-else>N/A</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Stage/Status"
                    min-width="100"
                    >
                    <template slot="header">
                        <div class="d-block">
                            <span class="sub-column-label">Status</span>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <b-badge pill class="text-white font-weight-500 bg-primary">{{ scope.row.prod_bnk_stage_status }}</b-badge>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Loan Amount/Interest/Margin/Tenure"
                    min-width="160"
                    >
                    <template slot="header">
                        <div class="d-block">
                            <span class="main-column-label">Loan Amount</span><br>
                            <span class="sub-column-label">/Interest/Tenure</span>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM{{ scope.row.prod_bnk_loan_amount | moneyFormatter }}</p>
                        <p class="bottom-line">
                            {{ scope.row.prod_bnk_interest }} | {{ scope.row.prod_bnk_tenure }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Instalment"
                    min-width="100"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM{{ scope.row.prod_bnk_installment | moneyFormatter }}</p>
                    </template>
                </el-table-column>
                <el-table-column min-width="90">
                    <template slot-scope="scope">
                        <div class="d-flex">
                            <el-button type="text" @click="editBankHandler(scope.row)" :disabled="isTerminalBankStatus(scope.row)">
                                <b-icon icon="pencil-square" class="mr-2"></b-icon>
                            </el-button>
                            <el-button class="px-0" @click="showBankDocumentHandler(scope.row)" type="text" v-b-tooltip.hover="'Documents'" :disabled="isTerminalBankStatus(scope.row)">
                                <b-icon icon="file-earmark-fill" class="text-success mr-2"></b-icon>
                            </el-button>
                            <el-button type="text" 
                                v-b-tooltip.hover="'Remove'" 
                                @click="removeBankHandler(scope.row)"
                                v-if="tableData.length > 1"
                            >
                                <b-icon icon="x-circle-fill" class="text-danger"></b-icon>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Button,Image } from 'element-ui'
import CaseDocuments from '@/views/CustomerProfile/CustomerModals/CasesDocumentsModal'
import { mapState } from 'pinia'
import { useLookupStore } from '@/stores/lookupStore'
import PersonalCaseEditBankModal from './Modals/PersonalCaseEditBankModal.vue'
import PersonalCaseAddBankModal from './Modals/PersonalCaseAddBankModal.vue'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'

export default {
    props: ['product'],
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    components: {
        PersonalCaseAddBankModal,
        PersonalCaseEditBankModal,
        CaseDocuments,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        [Image.name]: Image,
    },
    data() {
        return {
            tableData: [],
            modals: {
                show_documents: false,
                show_edit_bank: false,
                show_add_bank: false,
            },
            edit_bank: null,
            document_bank: null,
            current_bank_id:null
        }
    },
    watch:{
        'product.product_banks':{
            handler(newVal){
                this.tableData = newVal
                this.edit_bank = newVal[0],
                this.document_bank = newVal[0]
            },
            immediate: true
        }
    },
		computed: {
			...mapState(useLookupStore, ['list_sub_personal_loan_status']),
		},
    methods:{
        async removeBankHandler(bank){
            let message = 'Are you sure you want to remove the bank?'
            if(confirm(message) == true){
                try{
                    const res = await axios.post(services.product + 'product-bank/delete/'+bank.prod_bnk_id, null, {headers: getHeader()})
                    caseEventBus.$emit('refresh-cases')
                    this.notifySuccess('<b>Bank</b> - Successfully Removed.')
                }catch(e){
                    this.errorFunction(e)
                }
            }
        },
        editBankHandler(bank){
            this.edit_bank = bank
            this.modals.show_edit_bank = true
        },
        showBankDocumentHandler(bank){
            this.document_bank = bank
            this.$refs.bankDocuments.getCustomerAttachments()
            this.$refs.bankDocuments.getBankAttachments(bank.prod_bnk_id)
            this.modals.show_documents = true
        },
        showAddBankModal(){
            this.modals.show_add_bank = true
        },
        isTerminalBankStatus(bank){
            const statuses = [
                _gHlp.getValue(bank,'prod_bnk_stage_status'),
                _gHlp.getValue(bank,'prod_bnk_stage_status_label'),
                _gHlp.getValue(bank,'prod_bnk_status'),
                _gHlp.getValue(bank,'prod_bnk_stage_status_value'),
            ]
                .map(s => String(s || '').trim().toLowerCase())
                .filter(Boolean)

            if (!statuses.length) return false

            return statuses.some(s =>
                s.includes('reject') ||
                s.includes('decline') ||
                s.includes('cancel')
            )
        }
    }
}
</script>
